import {MutationTree} from "vuex";

const state: any = {
    v_poor_network_environment_counter: 0, // 弱网环境计数器
    v_poor_network_environment_status: false, // 弱网状态true 非弱网状态false
    v_is_reverse_order: false,  // 是否是反向下单
};

const mutations: MutationTree<any> = {
    add_poor_network_environment_counter(state): void {
        state.v_poor_network_environment_counter++;
    },
    reset_poor_network_environment_counter(state): void {
        state.v_poor_network_environment_counter = 0;
    },
    judge_poor_network_environment_status(state,boolean): void {
        state.v_poor_network_environment_status = boolean;
    },
    set_is_reverse_order(state, is_reverse): void{
        state.v_is_reverse_order = is_reverse;
    }
};

export default {namespaced: true, state, mutations};
